import axios from 'axios';
import { supabase } from './supabase';

// Cache the session token to avoid calling getSession() on every request
let cachedToken = null;
let tokenExpiresAt = 0;

// Listen for auth state changes to keep cache in sync
supabase.auth.onAuthStateChange((_event, session) => {
  if (session?.access_token) {
    cachedToken = session.access_token;
    tokenExpiresAt = (session.expires_at || 0) * 1000; // convert to ms
  } else {
    cachedToken = null;
    tokenExpiresAt = 0;
  }
});

// Attach Supabase JWT to every request using cached token
axios.interceptors.request.use(async (config) => {
  // Use cached token if still valid (with 60s buffer)
  config.timeout = config.timeout || 30000;
  if (cachedToken && Date.now() < tokenExpiresAt - 60000) {
    config.headers.Authorization = `Bearer ${cachedToken}`;
    return config;
  }
  // Otherwise refresh
  const { data: { session } } = await supabase.auth.getSession();
  if (session?.access_token) {
    cachedToken = session.access_token;
    tokenExpiresAt = (session.expires_at || 0) * 1000;
    config.headers.Authorization = `Bearer ${session.access_token}`;
  }
  return config;
});

// On 401, sign out so the user lands on the login page
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      await supabase.auth.signOut();
    }
    return Promise.reject(error);
  }
);

export default axios;

// Safe data helpers — ensure API responses are always the expected type
export const safeArray = (data) => Array.isArray(data) ? data : [];
export const safeObject = (data) => (data && typeof data === 'object' && !Array.isArray(data)) ? data : {};
